/**
 * Shared Quill editor setup for email composers.
 * Registers the image resize module once (idempotent) and exports
 * a helper to build modules config with imageResize enabled.
 */
import { Quill } from 'react-quill';
import ImageResize from 'quill-image-resize-module-react';

// Idempotent registration — safe to import from multiple components
let registered = false;
if (!registered) {
  Quill.register('modules/imageResize', ImageResize);
  registered = true;
}

/**
 * Standard Quill modules config for email editors with image resize.
 * Use inside `useMemo` or as a module-level constant (outside render).
 */
export const emailEditorModules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ['bold', 'italic', 'underline'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ color: [] }],
    ['link', 'image'],
    ['clean'],
  ],
  clipboard: {
    matchVisual: false,
  },
  imageResize: {
    parchment: Quill.import('parchment'),
    modules: ['Resize', 'DisplaySize', 'Toolbar'],
  },
};

/** Re-export Quill so consumers don't need a separate import for parchment. */
export { Quill };
